// src/EmailForm.js
import React, { useState } from 'react';
import axios from 'axios';

const CreateSendEmail = () => {
  const [formData, setFormData] = useState({
    to: '',
    subject: '',
    text: '',
    html: '',
  });
  const [message, setMessage] = useState('');

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Clear previous messages
    try {
      const response = await axios.post('https://api.eyorsolutions.com/api/send-email', formData);
      setMessage(`Email sent successfully! Message ID: ${response.data.messageId}`);
    } catch (error) {
      setMessage(`Failed to send email: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div className="email-form">
      <h2>Send an Email</h2>
      <form onSubmit={handleSubmit}>
        <label>
          To:
          <input type="email" name="to" value={formData.to} onChange={handleChange} required />
        </label>
        <label>
          Subject:
          <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
        </label>
        <label>
          Text Content:
          <textarea name="text" value={formData.text} onChange={handleChange} required />
        </label>
        <label>
          HTML Content (optional):
          <textarea name="html" value={formData.html} onChange={handleChange} />
        </label>
        <button type="submit">Send Email</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default CreateSendEmail;